import { render, staticRenderFns } from "./TPassBillBorder.vue?vue&type=template&id=40890348&"
import script from "./TPassBillBorder.vue?vue&type=script&lang=js&"
export * from "./TPassBillBorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports